<template>
  <section class="hbox stretch">
    <div class="content-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">系统</a></el-breadcrumb-item>
        <el-breadcrumb-item>消息模板</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true" size="medium">            
        <el-form-item >
          <el-input  placeholder="消息名称" v-model="queryParam.name" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="Search" size="small" >查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="messageTemplates" style="width: 100%">
        <el-table-column  prop="Title"  :show-overflow-tooltip="true" label="名称"> </el-table-column>
        <el-table-column  prop="SmsTemplate"  :show-overflow-tooltip="true" label="短信内容"> </el-table-column>
        <el-table-column  prop="WxTemplateTitle"  :show-overflow-tooltip="true" label="微信模板标题"> </el-table-column>
        <el-table-column  prop="WxTemplateNo"  label="微信模板编号"> </el-table-column>
        <el-table-column  prop="WxTemplateId"  :show-overflow-tooltip="true" label="微信模板Id" ></el-table-column>
        <el-table-column  prop="SendWay"  :show-overflow-tooltip="true" label="发送方式">
          <template slot-scope="scope">
            <p v-if="scope.row.SendWay==0"> 不发送</p>
            <p v-if="scope.row.SendWay==1"> 发送微信消息</p>
            <p v-if="scope.row.SendWay==2"> 发送短信消息</p>
            <p v-if="scope.row.SendWay==3"> 同时发送微信短信</p>
          </template>
        </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click.native.prevent="editMessageTemplate(scope.row)" type="text" size="small">
            编辑
          </el-button>
          <el-button @click="deleteRow(scope.row.TemplateKey)" type="text" size="small"> 默认</el-button>

        </template>
      </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParam.pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryParam.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryParam.totalCount">
      </el-pagination>
    </div>   
    <dia v-bind:dialog="dialog" ></dia>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import dia from './info'
  export default {
    props:{
    },
    data (){
      return {        
        messageTemplates:[],
        queryParam:{
          name:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:' Title asc',
        },
        dialog: {
          id:'0',
          title: '',
          isShow:false
        },
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/MessageTemplate/Index',
          params: this.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.messageTemplates = resp.data.messageTemplates
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      deleteRow(key) {
        this.$confirm('确定要恢复该消息模板吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/MessageTemplate/Delete',         
            data:{
              keyName:key
            }
          }).then(function (resp) {
            if(resp.data.errorCode==0){
              that.$message.success(resp.data.message)
              that.GetData()
            }else {
              that.$message.warning(resp.data.message)
            }  
          }).catch(resp => {         
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });        
      },
      editMessageTemplate:function(row){
        this.dialog.data = row
        this.dialog.title = row.Title
        this.dialog.isShow = true 
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.GetData()
      }
    },
    components:{    
      dia
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>